import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { useTranslation } from "react-i18next";

type Props = {
  patientsInfo: any;
};

const data = [
  {
    id: "Žene",
    label: "Žene",
    value: 586,
    color: "hsl(100, 70%, 50%)",
  },
  {
    id: "Muškarci",
    label: "Muškarci",
    value: 323,
    color: "hsl(53, 70%, 50%)",
  },
];
const DashboardPieChart: React.FC<Props> = ({ patientsInfo }) => {
  const { t } = useTranslation();
  console.log("PATIENTS INFO", patientsInfo);
  const data = [
    {
      id: t("Female"),
      label: t("Female"),
      value: patientsInfo?.genderNumber?.female ?? 0,
      color: "#3399cc",
    },
    {
      id: t("Male"),
      label: t("Male"),
      value: patientsInfo?.genderNumber?.male ?? 0,
      color: "#3399cc",
    },
  ];
  return (
    <div style={{ height: 300, width: "100%", position: "relative" }}>
      <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        colors={["#3399cc", "#66b2ff"]}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: "color",
          modifiers: [["darker", 2]],
        }}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "#3399cc",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "#3399cc",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        fill={[
          {
            match: {
              id: "ruby",
            },
            id: "dots",
          },
          {
            match: {
              id: "c",
            },
            id: "dots",
          },
          {
            match: {
              id: "go",
            },
            id: "dots",
          },
          {
            match: {
              id: "python",
            },
            id: "dots",
          },
          {
            match: {
              id: "scala",
            },
            id: "lines",
          },
          {
            match: {
              id: "lisp",
            },
            id: "lines",
          },
          {
            match: {
              id: "elixir",
            },
            id: "lines",
          },
          {
            match: {
              id: "javascript",
            },
            id: "lines",
          },
        ]}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export default DashboardPieChart;
